module.exports = __webpack_public_path__ + "static/media/nft-14.1b725adf.png";